import * as Global from './global';

export const environment = Object.assign(Global.environment, {
    production: true,
    environment: {
        platform: null,
    },
});
